import ApiService from "./api.service";
export default class HotelService extends ApiService {
    static base_url = `${super.base_url}/hotels`;
}
